<template>
  <!-- <div class="application"> -->
  <section id="page-content">
    <!-- Header -->
    <div id="customsearch" v-if="hideSearch && showSearch" class="searchBtn" style="margin-top: -86px;   z-index: 9999999 !important; margin-left:160px "
      @click="openSearch">
      <i class="far fa-search "></i> Search Availability
      <!-- <i v-else class="far fa-times rotateIn" :class="[showSearch ? 'animated' : 'rotateOut animated']"></i> -->
    </div>
    <nav id="custom-nav-bar" class="navbar fixed-top">
      <div id="headerMenu">


      </div>




    </nav>

    <div class="mainContent">
      <!-- <div>
          <span v-if="filterObj.Persons != -99">{{filterObj.Persons}} Guest(s)</span>
      </div> -->
      <!-- <div >
            <strong @click="openDatesPanel()" v-if="filterObj.startDate && filterObj.endDate">{{formatStartDate(filterObj.startDate)}}-{{formatendDate(filterObj.endDate)}}</strong>
            <strong v-if="filterObj.Persons != -99">{{filterObj.Persons}} Guest(s)</strong>
            <strong v-if="filterObj.Adults != -99">{{filterObj.Adults}} Adult(s)</strong>
            <strong v-if="filterObj.Children != -99">{{filterObj.Children}} Children</strong>
            <strong v-if="filterObj.Children != -99 && filterObj.Children == 1">{{filterObj.Children}} Child</strong>
            <strong>{{filterObj.Location.CityName}}</strong>
            <strong v-if="filterObj.startDate && filterObj.endDate" @click="openfilterpannel()">{{filterLabel}}</strong>
            <strong v-if="FiltersCount != 0 && filterLabel != 'Filter' ">-{{FiltersCount}}</strong>


            <div v-show="isPannelInfo" class="navbar-header">
                <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>

            </div>
            <div v-show="isPannelInfo" class="collapse navbar-collapse" id="myNavbar">
                <ul class="nav navbar-nav">
                    <li>
                        <a href="https://deedeesapartments.com/">Overview</a>
                        <span></span>
                    </li>
                    <li>
                        <a href="https://deedeesapartments.com/amazing-apartments/">Amazing Apartments</a>
                        <span></span>
                    </li>
                    <li>
                        <a href="https://deedeesapartments.com/great_service/">Great Service</a>
                        <span></span>
                    </li>
                    <li>
                        <a href="https://deedeesapartments.com/close-to-nyc/">Close to NYC</a>
                        <span></span>
                    </li>
                    <li>
                        <a href="https://deedeesapartments.com/explore_nyc_jc/">Explore NYC/JC</a>
                        <span></span>
                    </li>
                    <li>
                        <a href="https://deedeesapartments.com/deedee-says/">Deedee Says...</a>
                        <span></span>
                    </li>

                </ul>


            </div> -->
      <!-- </div> -->
      <div class="booking-eng"></div>
      <section class="appcontent container-fluid" v-bind:class="{ activeSideBar: isActive  }">
        <div id="leftMenuPanel"></div>
        <router-view></router-view>
        <div id="rightMenuPanel"></div>
      </section>

    </div>
    <div class="footerCom">


    </div>
  </section>

  <!-- </div> -->
</template>

<script>
  export default {
    name: "app",
    data() {
      return {
        msg: "Welcome to Your Vue.js App",
        hideSearch: true,
        showSearch: true

      };
    },
    methods: {
      openSearch() {
        let vm = this;
        this.showSearch = true;
        // this.hideSearch = false;
        vm.$store.state.bus.$emit("IsShowSearch", true);

      }
    },
    computed: {
      isVaildSubDomain() {
        let vm = this;
        if (vm.$store.state.isValidDomainOrNot == true) {
          return true;
        }
        return false;
      },


      isActive() {
        if (this.$store.state.beData.LeftPanelVisibility == true || this.$store.state.beData.RightPanelVisibility == true)
          return true;

        return false;
      }

    },
    created() {
      let vm = this;
      vm.$store.state.bus.$on("hidingSearch", function (bit) {
        
        vm.hideSearch = bit;
        console.log("herehidingSearch", vm.hideSearch)
        vm.showSearch = true;
      });

      if (window.innerWidth === 1024 && (window.innerHeight === 1366 || window.innerHeight === 768)) {
        vm.showSearch = false;
      }
      else {
        vm.showSearch = true;
      }

    }
  };
</script>

<style lang="scss">
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /* // margin-top: 60px; */
  }

  h1,
  h2 {
    font-weight: normal;
  }

  a {
    color: #42b983;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue